import Spinner from '@components/spinner';
import TawkTo from '@containers/tawk-to';
import ClarityComponent, { initClarity } from '@global/monitoring/clarity';
import { initSentry } from '@global/monitoring/sentry';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { persistor, store } from '@redux/store';
import { growthbook } from '@services/growthbook';
import { closeSnackbar, SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import CookieConsentProvider from '@components/provider/cookie-consent';
import App from './app';

if (import.meta.env.PROD) {
  initSentry();
}

initClarity();

// eslint-disable-next-line prettier/prettier
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <CookieConsentProvider>
        <BrowserRouter basename={import.meta.env.VITE_BASE_URL || '/'}>
          <SnackbarProvider
            maxSnack={2}
            preventDuplicate={true}
            style={{ fontSize: '1.2rem', fontWeight: '400' }}
            action={(snackbarKey) => (
              <IconButton onClick={() => closeSnackbar(snackbarKey as string)}>
                <CloseIcon sx={{ color: '#fff' }} />
              </IconButton>
            )}>
            <React.Suspense fallback={<Spinner />}>
              <GrowthBookProvider growthbook={growthbook}>
                <>
                  <App />
                </>
              </GrowthBookProvider>
            </React.Suspense>
            <TawkTo />
            <ClarityComponent />
          </SnackbarProvider>
        </BrowserRouter>
      </CookieConsentProvider>
    </PersistGate>
  </Provider>
);
